import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById('hero-cta');
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, []);
  return <AnimatePresence data-id="element-160" data-mp="bq9furzo3c1a">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-brand-100 bg-white/95 px-3 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 shadow-[0_-8px_24px_-12px_rgba(40,19,74,0.35)] backdrop-blur" data-id="element-161" data-mp="195wrtb2xzn8w">
          <div className="mx-auto flex max-w-xl items-center gap-3" data-id="element-162" data-mp="21dfdmcthm5nj">
            <div className="hidden shrink-0 text-left sm:block" data-id="element-163" data-mp="26bqn2mfvee58">
              <p className="text-xs font-bold uppercase tracking-wide text-muted" data-id="element-164" data-mp="269w6fkbmt86y">Launch price</p>
              <p className="font-serif text-2xl font-black leading-none text-cta-dark" data-id="element-165" data-mp="1rd534zyu7cc2">$27</p>
            </div>
            <a href={CHECKOUT_URL} className="animate-cta-shake flex flex-1 items-center justify-center gap-2 rounded-xl bg-cta px-4 py-4 text-center text-base font-extrabold uppercase tracking-wide text-white shadow-lg transition-colors duration-150 ease-out hover:bg-cta-hover focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40" data-id="element-166" data-mp="1wbgc78hb5it8">
              <span className="whitespace-nowrap" data-id="element-167" data-mp="3hq48lkn5ihi3">Get it now · $27</span>
              <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-168" data-mp="3fd0g3spykw1b" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}